import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { FullComponent } from "./shared/components/layout/full/full.component";
import { full } from "./shared/routes/full.routes";
import { content } from "./shared/routes/routes";
import { LoginComponent } from "./auth/login/login.component";

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: "public",
    loadChildren: () => import("./components/public/public.module").then((m) => m.PublicModule)
  },
  {
    path: 'onboarding',
    loadChildren: () => import("./components/onboarding/onboarding.module").then((m) => m.OnboardingModule)
  },
  {
    path: '',
    component: ContentComponent,
    // canActivate: [AuthGuard],
    children: content
  },
  {
    path: '',
    component: FullComponent,
    // canActivate: [AuthGuard],
    children: full
  },
  {
    path: '**',
    redirectTo: 'error'
  }
];

@NgModule({
  imports: [
    [
      RouterModule.forRoot(routes, {
        anchorScrolling: "enabled",
        scrollPositionRestoration: "enabled",
      }),
    ],
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
